import type { AutomationRule, SmartFolder } from "./types";

/** Gmail search query representing a Smart Folder's matching rule, e.g.
 *  `from:(amazon.in OR flipkart.com)`. */
export function smartFolderSearchQuery(folder: SmartFolder): string {
  if (folder.matchValues.length === 0) return "";
  const field = folder.matchField === "from" ? "from" : "subject";
  const joined = folder.matchValues.join(" OR ");
  return folder.matchValues.length === 1 ? `${field}:${folder.matchValues[0]}` : `${field}:(${joined})`;
}

/** Gmail search query an automation rule's condition maps to. */
export function ruleSearchQuery(rule: AutomationRule): string {
  switch (rule.conditionType) {
    case "senderContains":
      return `from:${rule.conditionValue}`;
    case "subjectContains":
      return `subject:${rule.conditionValue}`;
    case "isOtp":
      return 'subject:(OTP OR "one time password" OR verification code)';
    case "isNewsletter":
      return "unsubscribe";
    case "isPromotion":
      return "category:promotions";
  }
}
